import React from 'react';
import { useLocation } from 'react-router-dom';
import PageHero from '../components/PageHero';

const CONTENT = {
  privacy: {
    title: 'Privacy Policy',
    intro: 'Your privacy is important to us. This policy explains how National Light collects, uses and protects your information.',
    sections: [
      { h: 'Information We Collect', p: 'We collect information you provide when placing an order or contacting us, such as your name, phone number, email address and delivery address. This information is used solely to process your orders and respond to inquiries.' },
      { h: 'How We Use Your Information', p: 'Your information is used to fulfil orders, provide customer support, share order updates, and improve our products and services. We do not sell or rent your personal data to third parties.' },
      { h: 'WhatsApp Orders', p: 'When you place an order via WhatsApp, your order details are shared through the WhatsApp platform to facilitate communication and order confirmation.' },
      { h: 'Data Security', p: 'We implement appropriate security measures to protect your personal information against unauthorised access, alteration or disclosure.' },
      { h: 'Cookies', p: 'Our website may use cookies to enhance your browsing experience and remember your cart items. You can disable cookies in your browser settings.' },
      { h: 'Contact Us', p: 'If you have any questions about this Privacy Policy, please contact us using the details on our Contact page.' },
    ],
  },
  refund: {
    title: 'Refund & Return Policy',
    intro: 'We want you to be completely satisfied with your National Light purchase. Please review our refund and return terms below.',
    sections: [
      { h: 'Returns', p: 'Products may be returned within 7 days of delivery if they are defective or damaged on arrival. Items must be unused and in their original packaging.' },
      { h: 'Warranty Claims', p: 'All National Light products carry a 14-month warranty against manufacturing defects. Faulty units will be repaired or replaced free of charge under warranty terms.' },
      { h: 'Refunds', p: 'Once your return is received and inspected, approved refunds are processed within 7-10 business days via the original payment method or bank transfer.' },
      { h: 'Non-Returnable Items', p: 'Products damaged due to misuse, improper installation, or physical/electrical damage caused after delivery are not eligible for return or refund.' },
      { h: 'How to Request', p: 'To initiate a return or warranty claim, contact us via WhatsApp or our Contact page with your order number and a description of the issue.' },
    ],
  },
  terms: {
    title: 'Terms & Conditions',
    intro: 'By using the National Light website and placing an order, you agree to the following terms and conditions.',
    sections: [
      { h: 'General', p: 'All content on this website, including product descriptions, images and logos, is the property of National Light and may not be used without permission.' },
      { h: 'Orders & Pricing', p: 'All prices are listed in Pakistani Rupees (PKR) and are subject to change without notice. We reserve the right to refuse or cancel any order at our discretion.' },
      { h: 'Order Confirmation', p: 'Orders placed through the website or WhatsApp are confirmed once our team contacts you. Availability of products is subject to stock.' },
      { h: 'Delivery', p: 'We offer nationwide delivery across Pakistan. Delivery timelines are estimates and may vary based on location and courier availability.' },
      { h: 'Warranty', p: 'Products are covered under a 14-month warranty against manufacturing defects, subject to the terms in our Refund & Return Policy.' },
      { h: 'Limitation of Liability', p: 'National Light shall not be liable for any indirect or consequential damages arising from the use of our products beyond the value of the product purchased.' },
    ],
  },
};

const LegalPage = ({ type }) => {
  const location = useLocation();
  const key = type || (location.pathname.includes('privacy') ? 'privacy' : location.pathname.includes('refund') ? 'refund' : 'terms');
  const data = CONTENT[key];
  return (
    <div>
      <PageHero title={data.title} subtitle={data.intro} />
      <section className="max-w-4xl mx-auto px-4 py-14">
        <p className="text-sm text-gray-400 mb-8">Last updated: {new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long' })}</p>
        <div className="space-y-8">
          {data.sections.map((s, i) => (
            <div key={i}>
              <h2 className="font-head text-xl font-bold text-[#14181b] mb-2">{i + 1}. {s.h}</h2>
              <p className="text-gray-600 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default LegalPage;
